import { faCheckSquare, faClipboardCheck, faFileContract, faFileInvoice, faFilePrescription, faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import { Check2Square, DashCircle, FileEarmarkCheck } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function ModalBihamtaGuarantee({ modalData, setModalData }) {

    const history = useHistory();
    if (!modalData?.show || !(Number(modalData?.RemainedDays) > 0)) {
        return null;
    }

    const discount = Number(modalData?.Month) * 10;
    function handleCancel() {
        setModalData({ show: false });
        modalData.onClose?.();
    }
    function handleExtend() {
        modalData.onClose?.();
        history.push("/GuaranteeExtend");
    }
    return (

        <Modal show={modalData.show}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faFileContract} size="lg" />&nbsp;
                    گارانتی نرم افزار
                </span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <ul>
                    <li>گارانتی نرم افزار در تاریخ <strong>{modalData.PExpDate}</strong> به پایان می رسد.</li>
                    <li>{Number(modalData.RemainedDays) <= 30 ? "تنها " : ""} <label className="opacity-animation" style={{ fontWeight: "900" }}>{modalData.RemainedDays}</label> روز به پایان گارانتی باقی مانده است.</li>
                    {discount &&
                        <li>اکنون اقدام کنید تا از <label className="heart-animation" style={{ color: "#a81111" }}>{discount}%</label> تخفیف بهره مند شوید.</li>
                    }
                </ul>
                <div>
                    <Button variant="info" className="group-Btn" onClick={handleExtend}><Check2Square size={18} /> تمدید گارانتی</Button>
                    <Button variant="danger" className="group-Btn" onClick={handleCancel}><DashCircle size={18} /> انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}